import { render, staticRenderFns } from "./CartListItemCard.vue?vue&type=template&id=65dd4a60"
import script from "./CartListItemCard.vue?vue&type=script&lang=js"
export * from "./CartListItemCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports